import React, { useEffect } from "react";
import { AppRouter } from "./router";
import { AuthProvider } from "./context/AuthContext";

export const App: React.FC = () => {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/service-worker.js")
        .catch((err) => console.error("SW registration failed", err));
    }
  }, []);

  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
};
